import React, { useState } from "react";
import { Link } from "gatsby";
import { Menu, X } from "react-feather";
import PropTypes from "prop-types";
import cn from "classnames";
import logo from "../../images/logo.jpg";

import {
  header,
  headerLinks,
  headerLink,
  headerHamburger,
  headerLinksClosed,
} from "./styles.module.css";

const Header = () => {
  const [menuOpen, toggleMenu] = useState(false);

  const linkClasses = cn(headerLinks, {
    [`${headerLinksClosed}`]: menuOpen === false,
  });

  return (
    <header className={header}>
      <div>
        <Link
          to="/"
          style={{
            color: "white",
            textDecoration: "none",
          }}
        >
          <h2 style={{ paddingLeft: "10px" }}>Ariel's Blog</h2>
        </Link>
      </div>
      <div className={linkClasses}>
        <Link to="/tags/portfolio" className={headerLink}>
          Portfolio
        </Link>
        <Link to="/tags/thoughts" className={headerLink}>
          Thoughts
        </Link>
        <Link to="/tags/development" className={headerLink}>
          Development
        </Link>
        <a href="https://arielwolffe.com/about.html" className={headerLink}>
          About
        </a>
      </div>
      <button
        className={headerHamburger}
        onClick={() => toggleMenu(!menuOpen)}
        type="button"
      >
        {menuOpen ? <X /> : <Menu />}
      </button>
    </header>
  );
};

export default Header;
